export default __webpack_public_path__ + "static/media/event4.739de30a.png";